module.exports = { "default": require("core-js/library/fn/number/is-integer"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/babel-runtime/core-js/number/is-integer.js
// module id = 758
// module chunks = 0